<template>
  <div>
    <grid-layout :rowHeight="30" :responsive="true" :layout.sync="widgets" :dragAllowFrom="'.widget-title'" :autoSize="true" :margin="[10, 10]" @layout-updated="updateWidgetsInStorage">
      <grid-item v-for="(item, key) in widgets" v-bind="item" :key="item.i" :static="!appdata.editable" class="widget">
        <img v-if="appdata.loading == true" src="../assets/loading.gif" class="loading" />
        <a href="#" @click="removeWidget(key)" class="removeWidget" v-if="appdata.editable == true">&times;</a>
        <h3 class="text-center widget-title" v-if="item.options.title" :title="ld.get(appdata.response, item.options.module, {'date': ''}).date">{{ item.options.title }}</h3>
        <component class="widget-item" :appdata="appdata" :is="item.options.type || 'Gauge'" :options="item.options" />
      </grid-item>
    </grid-layout>
  </div>
</template>

<script>
  import VueGridLayout from 'vue-grid-layout'

  import { get } from 'lodash';
  import Clock from '../components/widgets/Clock.vue'
  import Gauge from '../components/widgets/Gauge.vue'
  import ImageCarousel from '../components/widgets/ImageCarousel.vue'
  import ImageWidget from '../components/widgets/ImageWidget.vue'
  import Kp3Day from '../components/widgets/Kp3Day.vue'
  import SunMoon from '../components/widgets/SunMoon.vue'
  import TableWidget from '../components/widgets/TableWidget.vue'
  import Value from '../components/widgets/Value.vue'
  import Weather from '../components/widgets/Weather.vue'
  import Welcome from '../components/widgets/Welcome.vue'
  import DefaultWidgets from '../data/widgets.json'


  export default {
    name: 'dashboard',
    components: {
      VueGridLayout,
      Clock,
      Gauge,
      ImageCarousel,
      ImageWidget,
      Kp3Day,
      SunMoon,
      TableWidget,
      Value,
      Weather,
      Welcome
    },

    methods: {
      track () {
        this.$ga.page(this.$route.path)
      },
      resetWidgets: function() {
        window.localStorage.removeItem('auroraslive-widget-layout')
        window.location.reload()
      },

      removeWidget: function(key) {
        this.widgets.splice(key, 1);
        this.updateWidgetsInStorage(this.widgets)
      },

      updateWidgetsInStorage: function(newLayout) {
        window.localStorage.setItem('auroraslive-widget-layout', JSON.stringify(newLayout))
      },

    },

    mounted() {
      const urlParams = new URLSearchParams(window.location.search);
      if(urlParams.get('reset') && JSON.parse(window.localStorage.getItem('auroraslive-widget-layout'))) {
        this.resetWidgets()
      }
    },

    data() {
      return {
        widgets: JSON.parse(window.localStorage.getItem('auroraslive-widget-layout')) || DefaultWidgets,
        error: null,
        ld: {
          get: _.get
        },
      }
    },

    props: ["appdata", "options"],
  }
</script>

<style scoped>
  .loading {
    width: 32px;
    left: 1%;
    position: absolute;
  }

  .removeWidget {
    position: absolute;
    padding: 5px 0.75em;
    right: 0;
    text-decoration: none;
  }

  .vue-grid-item {
    border: 1px solid #666;
    padding: 0;
    border-collapse: collapse;
    background: rgba(255, 255, 255, 0.025);
    overflow-x: hidden;
  }

  .widget-item {
    overflow-x: hidden;
    overflow-y: auto;
  }

  .header-spacer {
    margin-top: 70px !important;
  }

  .widget-title {
    background: rgba(255, 255, 255, 0.05);
    padding: 5px;
  }

</style>
